import api from './api';

export const getClaims = (params) =>
  api.get('/api/v1/insurance/claims', { params }).then((r) => r.data.data);

export const getClaim = (id) =>
  api.get(`/api/v1/insurance/claims/${id}`).then((r) => r.data.data);

export const createClaim = (data) =>
  api.post('/api/v1/insurance/claims', data).then((r) => r.data.data);

export const updateClaim = (id, data) =>
  api.put(`/api/v1/insurance/claims/${id}`, data).then((r) => r.data.data);

export const transitionClaim = (id, status) =>
  api.post(`/api/v1/insurance/claims/${id}/transition`, { status }).then((r) => r.data.data);

export const deleteClaim = (id) =>
  api.delete(`/api/v1/insurance/claims/${id}`).then((r) => r.data);

export const getERAs = () =>
  api.get('/api/v1/insurance/eras').then((r) => r.data.data);

export const getERA = (id) =>
  api.get(`/api/v1/insurance/eras/${id}`).then((r) => r.data.data);

export const createERA = (data) =>
  api.post('/api/v1/insurance/eras', data).then((r) => r.data.data);

export const parseERA835 = (file) => {
  const form = new FormData();
  form.append('file', file);
  return api.post('/api/v1/insurance/eras/parse', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then((r) => r.data.data);
};

export const postERAFrom835 = (data) =>
  api.post('/api/v1/insurance/eras/post-835', data).then((r) => r.data.data);

export const downloadSuperbill = async (id, claimNumber) => {
  // May return a 422 JSON if required fields are missing — handle that case
  const response = await api.get(`/api/v1/insurance/claims/${id}/superbill`, {
    responseType: 'blob',
    validateStatus: (s) => s < 500,
  });
  if (response.status === 422) {
    // Parse the JSON error from the blob
    const text = await response.data.text();
    const err = JSON.parse(text);
    const error = new Error(err.message || 'Missing required fields');
    error.missing = err.missing || [];
    throw error;
  }
  const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `superbill-${claimNumber || id}.pdf`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const downloadCMS1500 = async (id) => {
  const response = await api.get(`/api/v1/insurance/claims/${id}/cms1500`, {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `cms1500-${id}.pdf`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const submitClaim = (id) =>
  api.post(`/api/v1/insurance/claims/${id}/submit`).then((r) => r.data);

export const downloadEDI837 = async (id, claimNumber) => {
  const response = await api.get(`/api/v1/insurance/claims/${id}/edi837`, {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/plain' }));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `claim-837p-${claimNumber || id}.edi`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
